import { HttpResponse, IHttpInterceptor } from "@miracledevs/paradigm-web-fetch";
import { LoginService } from "../../LoginService";

export class AuthenticationInterceptor implements IHttpInterceptor
{
    constructor(private readonly loginService: LoginService)
    {
    }

    afterReceive(response: HttpResponse): HttpResponse
    {
        if (response.status === 401)
        {
            this.loginService.logout();
            document.location.href = "/login";
        }

        return response;
    }
}